// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"5fbfe255","623":"655d8b93","787":"1622b7c0"}[chunkId] + ".chunk.js";
};